<mat-grid-list cols="1" [rowHeight]="height">
  <mat-grid-tile>
    <div class="text-container" [style.width]="widthContainer">
      <div *ngIf="iconSvg; else icon" class="pt-32">
        <img [src]="'/assets/svg/'+iconSvg" alt="icon" [width]="iconSize" [height]="iconSize" />
      </div>
      <ng-template #icon>
        <div class="pt-32 pb-16">
          <mat-icon>{{iconClass}}</mat-icon>
        </div>
      </ng-template>
      <p *ngIf="title" class="fs-20 fw-500 leading-6">{{ title }}</p>
      <span *ngIf="subtitle" class="fs-14" [class]="title ? '' : 'fw-500'"> {{ subtitle }} </span>
      <ng-content></ng-content>
    </div>
  </mat-grid-tile>
</mat-grid-list>
